import './App.scss';
import MainRouter from './router';

const App = () => {
    return (<MainRouter />);
};

export default App;
